import { Link, useLoaderData } from "react-router-dom";
import * as API from "../services/psqi";

import { calculatePsqiResults } from "./PsqiCalc";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getPsqiByID(params.psqiId);
}

export function PsqiPacienteItem(props) {
  const psqi = useLoaderData();
  const errorMessage = psqi.message;

  const metaFecha = psqi.meta?.metaFecha;

  // Obtener resultados calculados
  const psqiResults = calculatePsqiResults(psqi.meta);

  // Asignar variables con nombres específicos
  const totalSumComp1 = psqiResults.calidadDelSueno;
  const totalSumComp2 = psqiResults.latenciaDelSueno;
  const totalSumComp3 = psqiResults.duraciónDelSueno;
  const totalSumComp4 = psqiResults.eficienciaDelSueno;
  const totalSumComp5 = psqiResults.despertaresNocturnos;
  const totalSumComp6 = psqiResults.usoDeMedicamentos;
  const totalSumComp7 = psqiResults.disfunciónDiurna;
  const totalSumCompT = psqiResults.puntuacionGlobal;


  // resultados cuestionario cards
  const createResultProperties = (result, low, high) => {
    // Convertir los strings que vienen del meta a numbers
    result = parseFloat(result);
    low = parseFloat(low);
    high = parseFloat(high);
    const color =
      result >= low && result <= high
        ? "anali-result-good"
        : "anali-result-bad";
    const markIn = Math.min(
      Math.max(((result - low) / (high - low)) * 100, 0),
      100
    ).toFixed(0);
    const markOut =
      result < low
        ? "anali-result-low"
        : result > high
        ? "anali-result-high"
        : "";
    return { color, markIn, markOut };
  };

  // Graphics

  const limits = {
    compT: { low: 0, high: 21 },
    comp1: { low: 0, high: 3 },
    comp2: { low: 0, high: 3 },
    comp3: { low: 0, high: 3 },
    comp4: { low: 0, high: 3 },
    comp5: { low: 0, high: 3 },
    comp6: { low: 0, high: 3 },
    comp7: { low: 0, high: 3 },
  };

  const {
    color: sumCompTColor,
    markIn: sumCompTMarkIn,
    markOut: sumCompTMarkOut,
  } = createResultProperties(totalSumCompT, limits.compT.low, limits.compT.high);

  const {
    color: sumComp1Color,
    markIn: sumComp1MarkIn,
    markOut: sumComp1MarkOut,
  } = createResultProperties(totalSumComp1, limits.comp1.low, limits.comp1.high);
  
  const {
    color: sumComp2Color,
    markIn: sumComp2MarkIn,
    markOut: sumComp2MarkOut,
  } = createResultProperties(totalSumComp2, limits.comp2.low, limits.comp2.high);
  
  const {
    color: sumComp3Color,
    markIn: sumComp3MarkIn,
    markOut: sumComp3MarkOut,
  } = createResultProperties(totalSumComp3, limits.comp3.low, limits.comp3.high);
  
  const {
    color: sumComp4Color,
    markIn: sumComp4MarkIn,
    markOut: sumComp4MarkOut,
  } = createResultProperties(totalSumComp4, limits.comp4.low, limits.comp4.high);
  
  const {
    color: sumComp5Color,
    markIn: sumComp5MarkIn,
    markOut: sumComp5MarkOut,
  } = createResultProperties(totalSumComp5, limits.comp5.low, limits.comp5.high);
  
  const {
    color: sumComp6Color,
    markIn: sumComp6MarkIn,
    markOut: sumComp6MarkOut,
  } = createResultProperties(totalSumComp6, limits.comp6.low, limits.comp6.high);
  
  const {
    color: sumComp7Color,
    markIn: sumComp7MarkIn,
    markOut: sumComp7MarkOut,
  } = createResultProperties(totalSumComp7, limits.comp7.low, limits.comp7.high);

  const sumPsqiLow = 0;
  const sumPsqiHigh = 10;

  return (
    <>
      <div id="content">
        {psqi.length === 0 ? (
          <div>Cargando...</div>
        ) : errorMessage ? (
          <p>{errorMessage}</p>
        ) : (
          <>
            <form id="formUpdatelement" className="newRadioButtons">
              <fieldset id="disabledContainer" disabled="disabled">
                <div className="grid--2col">
                  <div className="field">
                    <label htmlFor="metaFecha">Fecha de Respuesta al Cuestionario</label>
                    <div className="control">
                      <input
                        className="input"
                        id="metaFecha"
                        required
                        type="date"
                        value={metaFecha}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </fieldset>
            </form>
            <form className="analitic-form">
              <h3>Cuestionario PSQI</h3>
              <div className="three-col-analitic">

                {/* Componente 0: Puntuación Global PSQI */}
                <div className="anali-el">
                  <p className="anali-title">Puntuación Global</p>
                  {totalSumCompT !== '' && (
                    <div className="anali-result-container">
                      <p className={`anali-result ${sumCompTColor}`}>
                        {totalSumCompT}
                      </p>
                      <div className={`anali-bar-full ${sumCompTMarkOut}`}>
                        <div className="anali-bar anali-bar-low"></div>
                        <div className="anali-bar anali-bar-main">
                          <div
                            className="anali-bar-mark"
                            style={{
                              left: `${sumCompTMarkIn}%`,
                            }}
                          ></div>
                        </div>
                        <div className="anali-bar anali-bar-high"></div>
                      </div>
                      <div className="anali-limit-container">
                        <p className="anali-limit anali-limit-low">
                          {limits.compT.low}
                        </p>
                        <p className="anali-limit anali-limit-high">
                          {limits.compT.high}
                        </p>
                      </div>
                    </div>
                  )}
                </div>

                {/* Componente 1: Calidad subjetiva del sueño */}
                <div className="anali-el">
                  <p className="anali-title">Calidad subjetiva del sueño</p>
                  {totalSumComp1 !== '' && (
                    <div className="anali-result-container">
                      <p className={`anali-result ${sumComp1Color}`}>
                        {totalSumComp1}
                      </p>
                      <div className={`anali-bar-full ${sumComp1MarkOut}`}>
                        <div className="anali-bar anali-bar-low"></div>
                        <div className="anali-bar anali-bar-main">
                          <div
                            className="anali-bar-mark"
                            style={{
                              left: `${sumComp1MarkIn}%`,
                            }}
                          ></div>
                        </div>
                        <div className="anali-bar anali-bar-high"></div>
                      </div>
                      <div className="anali-limit-container">
                        <p className="anali-limit anali-limit-low">
                          {limits.comp1.low}
                        </p>
                        <p className="anali-limit anali-limit-high">
                          {limits.comp1.high}
                        </p>
                      </div>
                    </div>
                  )}
                </div>

                {/* Componente 2: Latencia de sueño */}
                <div className="anali-el">
                  <p className="anali-title">Latencia de sueño</p>
                  {totalSumComp2 !== '' && (
                    <div className="anali-result-container">
                      <p className={`anali-result ${sumComp2Color}`}>
                        {totalSumComp2}
                      </p>
                      <div className={`anali-bar-full ${sumComp2MarkOut}`}>
                        <div className="anali-bar anali-bar-low"></div>
                        <div className="anali-bar anali-bar-main">
                          <div
                            className="anali-bar-mark"
                            style={{
                              left: `${sumComp2MarkIn}%`,
                            }}
                          ></div>
                        </div>
                        <div className="anali-bar anali-bar-high"></div>
                      </div>
                      <div className="anali-limit-container">
                        <p className="anali-limit anali-limit-low">
                          {limits.comp2.low}
                        </p>
                        <p className="anali-limit anali-limit-high">
                          {limits.comp2.high}
                        </p>
                      </div>
                    </div>
                  )}
                </div>

                {/* Componente 3: Duración del sueño */}
                <div className="anali-el">
                  <p className="anali-title">Duración del sueño</p>
                  {totalSumComp3 !== '' && (
                    <div className="anali-result-container">
                      <p className={`anali-result ${sumComp3Color}`}>
                        {totalSumComp3}
                      </p>
                      <div className={`anali-bar-full ${sumComp3MarkOut}`}>
                        <div className="anali-bar anali-bar-low"></div>
                        <div className="anali-bar anali-bar-main">
                          <div
                            className="anali-bar-mark"
                            style={{
                              left: `${sumComp3MarkIn}%`,
                            }}
                          ></div>
                        </div>
                        <div className="anali-bar anali-bar-high"></div>
                      </div>
                      <div className="anali-limit-container">
                        <p className="anali-limit anali-limit-low">
                          {limits.comp3.low}
                        </p>
                        <p className="anali-limit anali-limit-high">
                          {limits.comp3.high}
                        </p>
                      </div>
                    </div>
                  )}
                </div>

                {/* Componente 4: Eficiencia habitual del sueño */}
                <div className="anali-el">
                  <p className="anali-title">Eficiencia habitual del sueño</p>
                  {totalSumComp4 !== '' && (
                    <div className="anali-result-container">
                      <p className={`anali-result ${sumComp4Color}`}>
                        {totalSumComp4}
                      </p>
                      <div className={`anali-bar-full ${sumComp4MarkOut}`}>
                        <div className="anali-bar anali-bar-low"></div>
                        <div className="anali-bar anali-bar-main">
                          <div
                            className="anali-bar-mark"
                            style={{
                              left: `${sumComp4MarkIn}%`,
                            }}
                          ></div>
                        </div>
                        <div className="anali-bar anali-bar-high"></div>
                      </div>
                      <div className="anali-limit-container">
                        <p className="anali-limit anali-limit-low">
                          {limits.comp4.low}
                        </p>
                        <p className="anali-limit anali-limit-high">
                          {limits.comp4.high}
                        </p>
                      </div>
                    </div>
                  )}
                </div>

                {/* Componente 5: Alteraciones del sueño */}
                <div className="anali-el">
                  <p className="anali-title">Alteraciones del sueño</p>
                  {totalSumComp5 !== '' && (
                    <div className="anali-result-container">
                      <p className={`anali-result ${sumComp5Color}`}>
                        {totalSumComp5}
                      </p>
                      <div className={`anali-bar-full ${sumComp5MarkOut}`}>
                        <div className="anali-bar anali-bar-low"></div>
                        <div className="anali-bar anali-bar-main">
                          <div
                            className="anali-bar-mark"
                            style={{
                              left: `${sumComp5MarkIn}%`,
                            }}
                          ></div>
                        </div>
                        <div className="anali-bar anali-bar-high"></div>
                      </div>
                      <div className="anali-limit-container">
                        <p className="anali-limit anali-limit-low">
                          {limits.comp5.low}
                        </p>
                        <p className="anali-limit anali-limit-high">
                          {limits.comp5.high}
                        </p>
                      </div>
                    </div>
                  )}
                </div>

                {/* Componente 6: Uso de medicación para dormir */}
                <div className="anali-el">
                  <p className="anali-title">Uso de medicación para dormir</p>
                  {totalSumComp6 !== '' && (
                    <div className="anali-result-container">
                      <p className={`anali-result ${sumComp6Color}`}>
                        {totalSumComp6}
                      </p>
                      <div className={`anali-bar-full ${sumComp6MarkOut}`}>
                        <div className="anali-bar anali-bar-low"></div>
                        <div className="anali-bar anali-bar-main">
                          <div
                            className="anali-bar-mark"
                            style={{
                              left: `${sumComp6MarkIn}%`,
                            }}
                          ></div>
                        </div>
                        <div className="anali-bar anali-bar-high"></div>
                      </div>
                      <div className="anali-limit-container">
                        <p className="anali-limit anali-limit-low">
                          {limits.comp6.low}
                        </p>
                        <p className="anali-limit anali-limit-high">
                          {limits.comp6.high}
                        </p>
                      </div>
                    </div>
                  )}
                </div>

                {/* Componente 7: Disfunción diurna */}
                <div className="anali-el">
                  <p className="anali-title">Disfunción diurna</p>
                  {totalSumComp7 !== '' && (
                    <div className="anali-result-container">
                      <p className={`anali-result ${sumComp7Color}`}>
                        {totalSumComp7}
                      </p>
                      <div className={`anali-bar-full ${sumComp7MarkOut}`}>
                        <div className="anali-bar anali-bar-low"></div>
                        <div className="anali-bar anali-bar-main">
                          <div
                            className="anali-bar-mark"
                            style={{
                              left: `${sumComp7MarkIn}%`,
                            }}
                          ></div>
                        </div>
                        <div className="anali-bar anali-bar-high"></div>
                      </div>
                      <div className="anali-limit-container">
                        <p className="anali-limit anali-limit-low">
                          {limits.comp7.low}
                        </p>
                        <p className="anali-limit anali-limit-high">
                          {limits.comp7.high}
                        </p>
                      </div>
                    </div>
                  )}
                </div>

              </div>
            </form>
          </>
        )}
      </div>
      {!errorMessage && (
        <div id="actions">
        </div>
      )}
    </>
  );
}
